import React from "react";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Boton from "../boton/Boton";
import Error from "../generales/Error";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Colors from "components/etiquetas/Colors";

const FormularioMeta = ({ meta }) => {
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const nuevaMetaSchema = Yup.object().shape({
    concepto_meta: Yup.string(),
    inicio: Yup.date().required("Este campo es obligatorio"),
    vencimiento: Yup.date().required("Este campo es obligatorio"),
    importe: Yup.number()
      .positive("Importe no válido")
      .typeError("Sólo valores númericos")
      .required("Este campo es obligatorio"),
    periodo: Yup.string().required("Este campo es obligatorio"),
    color: Yup.string(),
  });

  const handleSubmit = async (valoresMeta) => {
    try {
      const url = "http://localhost:4000/gastos";
      const { status } = await axios.post(url, valoresMeta);
      if (status === 200) {
      }
      navigate("/ahorro/metas");
    } catch (error) {
      setError(true);
      return;
    }
    setError(false);
  };

  return (
    <Formik
      initialValues={{
        concepto_meta: meta?.concepto_meta ?? "",
        inicio: meta?.inicio ?? "",
        vencimiento: meta?.vencimiento ?? "",
        importe: meta?.importe ?? "",
        periodo: meta?.periodo ?? "",
        color: meta?.color ?? "",
      }}
      onSubmit={async (values, { resetForm }) => {
        await handleSubmit(values);
        resetForm();
      }}
      validationSchema={nuevaMetaSchema}
    >
      {({ errors, touched }) => {
        return (
          <Form>
            <div className="formulario-input">
              <label htmlFor="concepto_meta">Concepto</label>
              <Field
                id="concepto_meta"
                type="textarea"
                placeholder="Descripción de la meta"
                name="concepto_meta"
              />
              {errors.concepto_meta && touched.concepto_meta ? (
                <Error>{errors.concepto_meta}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="inicio">Fecha de inicio</label>
              <Field
                id="inicio"
                type="date"
                value="2022-01-01"
                name="inicio"
              />
              {errors.inicio && touched.inicio ? (
                <Error>{errors.inicio}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="vencimiento">Fecha de vencimiento</label>
              <Field
                id="vencimiento"
                type="date"
                value="2022-01-31"
                name="vencimiento"
              />
              {errors.vencimiento && touched.vencimiento ? (
                <Error>{errors.vencimiento}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="importe">Importe</label>
              <Field
                id="importe"
                type="number"
                placeholder="$ "
                name="importe"
              />
              {errors.importe && touched.importe ? (
                <Error>{errors.importe}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="periodo">Periodo</label>
              <Field component="select" id="periodo" name="periodo">
                <option value="">Elige el periodo</option>
                <option value="Samanal">Semanal</option>
                <option value="Quincenal">Quincenal</option>
                <option value="Mensual">Mensual</option>
              </Field>
              {errors.periodo && touched.periodo ? (
                <Error>{errors.periodo}</Error>
              ) : null}
            </div>

            <div className="total" id="total">Total: $ ____ </div>

            <Colors />
            <br></br>

            <Boton>Guardar</Boton>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FormularioMeta;
